import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  incom: {
    borderBottom: "10px solid rgba(0 , 255 , 0 , .5)",
  },
  expense: {
    borderBottom: "10px solid rgba( 255 ,0 , 0 , .5)",
  },
}));
